/* offline_discovery_download.icon.svg.js */

module.exports = {
    icon: `
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_1246_28" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
    <rect width="24" height="24" transform="matrix(-1 0 0 1 24 0)"  class="foreground-gl"/>
    </mask>
    <g mask="url(#mask0_1246_28)">
    <path d="M9.53125 1.38672V8.36914L13.8975 4.00293L15.665 5.77051L8.24512 13.1904L1.3623 5.73438L3.2002 4.03906L7.03125 8.18848V1.38672H9.53125Z" class="foreground-gl"/>
    <path d="M17.8037 9.8877C14.7626 9.88807 12.2971 12.3534 12.2969 15.3945C12.2969 16.466 12.6055 17.4646 13.1348 18.3105L9.45801 21.9961L11.2275 23.7617L14.9043 20.0762C15.7465 20.5991 16.7395 20.9022 17.8037 20.9023C20.8453 20.9023 23.3115 18.4361 23.3115 15.3945C23.3113 12.3532 20.8451 9.8877 17.8037 9.8877ZM17.8037 12.3877C19.4644 12.3877 20.8113 13.7339 20.8115 15.3945C20.8115 17.0554 19.4645 18.4023 17.8037 18.4023C16.1432 18.402 14.7969 17.0551 14.7969 15.3945C14.7971 13.7341 16.1433 12.3881 17.8037 12.3877Z" class="foreground-gl"/>
    </g>
    </svg>
    `,
};
